import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { Router } from './lib/router';
import './styles/app.css';

const root = document.getElementById('root');
if (!root) throw new Error('#root missing from index.html');

createRoot(root).render(
  <StrictMode>
    <Router>
      <App />
    </Router>
  </StrictMode>,
);
